import {
    ValideursDesDossiersDossierValidatorResponseDtoJsonldValidatorsDossierRead as DossierValidator,
    ProcDureDeValidationDesDossiersJsonldDossierValideursStatusRead as DossierValidatorStatus,
} from '@europrocurement/l2d-domain/openApi/ApiFormalite';
import { createContext, useContext } from 'react';

const validators: Array<DossierValidator> = [];
const setValidators: React.Dispatch<React.SetStateAction<DossierValidator[]>> = () => {};
const validatorsStatus: Array<DossierValidatorStatus> = [];
const setValidatorsStatus: React.Dispatch<
    React.SetStateAction<DossierValidatorStatus[]>
> = () => {};

const DossierValidatorContext = createContext({
    validators,
    setValidators,
    validatorsStatus,
    setValidatorsStatus,
});

export const useDossierValidatorContext = () => useContext(DossierValidatorContext);

export default DossierValidatorContext;
